import { createChatApp, initializeNotifications, type ChatAppOptions } from '@headshots/chat-app';
import { createPinia } from "pinia";
import { createApp, markRaw } from "vue";
import App from "./App.vue";
import "./assets/styles/main.css";
import eventBus from "./eventBus";
import i18n from "./i18n";
import router from "./router";
import "./types/vue.d";

const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});
const app = createApp(App);

app.config.globalProperties.$eventBus = eventBus;
app.use(i18n);
app.use(pinia);
app.use(router);

// Passer la vapidKey depuis les variables d'environnement
const vapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;

const options:Partial<ChatAppOptions> = {
  pinia: pinia
}

// Initialiser les notifications avec la vapidKey
initializeNotifications({ vapidKey })
  .then(() => {    
    createChatApp(options);
  })
  .catch((error:Error) => {
    console.error('Error initializing notifications:', error);
    createChatApp(options);
  });

app.mount("#app");